import { ComponentToPrint } from './ComponentToPrintTicket';
import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import ticket from "../../../assets/font-awesome/white/png/128/ticket.png";

function Preview({ item }) {
  const [dataLoaded, setDataLoaded] = useState(false);
  const onBeforeGetContentResolve = useRef();
  const componentRef = useRef();

  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => { // `react-to-print` will wait for this Promise to resolve before continuing
      // Load data
      onBeforeGetContentResolve.current = resolve;
      setDataLoaded(true); // When data is done loading

      setTimeout(() => {
        setDataLoaded(false);
    }, 2000);

    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: handleOnBeforeGetContent,
  });

  useEffect(() => {
    if (dataLoaded) {
      // Resolves the Promise, telling `react-to-print` it is time to gather the content of the page for printing
      onBeforeGetContentResolve.current();
    }
  }, [dataLoaded, onBeforeGetContentResolve]);

  return (
    <div>
      <button title="Print Tiket" onClick={handlePrint} className="btn btn-warning btn-sm rounded-0" style={{ backgroundImage: "url(" + ticket + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}></button>
      <ComponentToPrint item={item} ref={componentRef} />
    </div>
  );
}

export default Preview;



